module.exports = __webpack_public_path__ + "img/csv-file.33588388.svg";